export default __webpack_public_path__ + "static/media/search_icon.fc7e06f3.svg";